export default __webpack_public_path__ + "images/0x78a76316f66224cbaca6e70acb24d5ee5b2bd2c7.png";